import "@/user/common";
import React from "react";
import DetailStatus from "@/user/components/fair/detail_status";
import { sliderSetting, setColorClass } from "@/shared/calendar";
import { createRoot } from "react-dom/client";

// カレンダーの日付
const inputDateCheckBox = '.calendar input[name="date[]"]';
let fairDetailStatusRoot = null;

// 日付別の開催時間表示
const renderFairDetailStatus = (date, formattedDate) => {
  const fairDetailStatus = document.getElementById("fair-detail-status");
  const fairDays = fairDetailStatus.dataset.fair_days;
  const isCustomForm = fairDetailStatus.dataset.custom_form; // オリジナルフォーム利用しているか

  if (fairDetailStatusRoot === null) {
    fairDetailStatusRoot = createRoot(fairDetailStatus);
  }

  if (fairDays) {
    fairDetailStatusRoot.render(
      <DetailStatus
        date={date}
        formattedDate={formattedDate}
        fairDays={JSON.parse(fairDays)}
        isCustomForm={JSON.parse(isCustomForm)}
      />,
    );
  }
};

// 日付別の開催時間初期表示
const initializeFairDetailStatus = () => {
  const selectedDate = document.querySelector(`${inputDateCheckBox}:checked`);
  if (selectedDate) {
    const date = selectedDate.value;
    const formattedDate = selectedDate.dataset.date;
    renderFairDetailStatus(date, formattedDate);
  }
};

// 日付別の開催時間削除
const removeFairDetailStatus = () => {
  fairDetailStatusRoot.render(null);
};

document.addEventListener("DOMContentLoaded", () => {
  // 日付別の開催時間初期表示
  initializeFairDetailStatus();

  // カレンダーのカルーセル
  sliderSetting(true, false);

  // カレンダーの日付選択
  const allDateInputs = document.querySelectorAll(inputDateCheckBox);
  allDateInputs.forEach((dataInput) => {
    dataInput.addEventListener("change", (e) => {
      const target = e.currentTarget;
      if (target.checked) {
        // 選択した日付以外のチェックを外す
        allDateInputs.forEach((input) => {
          if (input.value !== target.value) {
            // eslint-disable-next-line no-param-reassign
            input.checked = false;
          }
        });
      }

      setColorClass(); // 日付にclass付与

      if (target.checked) {
        const date = target.value; // YYYY-MM-DD
        const formattedDate = target.dataset.date; // YYYY年MM月dd日(a)
        renderFairDetailStatus(date, formattedDate);
      } else {
        removeFairDetailStatus();
      }
    });
  });
});
